"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.promiseAllAsZippedObject = void 0;
const lodash_zipobject_1 = __importDefault(require("lodash.zipobject"));
function promiseAllAsZippedObject(obj, iterator) {
    return __awaiter(this, void 0, void 0, function* () {
        const keys = Object.keys(obj);
        const resList = yield Promise.all(keys.map(k => iterator(obj[k], k)));
        return lodash_zipobject_1.default(keys, resList);
    });
}
exports.promiseAllAsZippedObject = promiseAllAsZippedObject;
//# sourceMappingURL=promise-iterated-object.js.map